import { useEffect, useState } from 'react';
import request from 'superagent';
import config from '@plone/volto/registry';
import { UID_VARIABLES_ROUTE } from 'volto-base-addon/constants';

/**
 * Use contentUID to get task variables
 * @function useUIDVariablesPoll
 * @params {int} interval The polling interval
 * @params {string} uid ContentUID
 * @params {List} queryVariables List of variables to query
 * @params {bool} shouldPoll Whether to keep polling
 * @returns {Object} object with the variable results.
 */
export const useUIDVariablesPoll = (
  interval,
  uid,
  queryVariables,
  shouldPoll = true,
) => {
  const [variables, setVariables] = useState(null);
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    let timer;

    // Only execute the polling logic if shouldPoll is true
    if (shouldPoll) {
      (async () => {
        try {
          const resp = await request
            .get(`${config.settings.publicPath}/${UID_VARIABLES_ROUTE}/${uid}`)
            .query({ 'variables[]': queryVariables })
            .set('Accept', 'application/json');

          if (Object.keys(resp.body).length > 0) {
            setVariables(resp.body);
          } else {
            setVariables(null);
          }
        } catch (e) {}
      })();

      timer = setTimeout(() => setCounter(counter + 1), interval);
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [counter, shouldPoll]);

  return variables;
};
